import { Component, Input } from "@angular/core"
import { LessonContent } from "../../../../models/lessonContent.model"
import Utils from "../../../../utils/utils"
import { AddOnViewService } from "../../../../services/add-on-view.service"
import { Router } from "@angular/router"
import { Resource } from "../../../../models/resource/resource"

@Component({
    selector: "app-lesson-content",
    templateUrl: "./lesson-content.component.html",
    styleUrls: ["./lesson-content.component.scss"],
    standalone: false,
})
export class LessonContentComponent {
    @Input() public lessonContent: LessonContent

    constructor(
        private addOnService: AddOnViewService,
        private router: Router
    ) {}

    public goToResource(e: MouseEvent) {
        e.preventDefault()
        this.addOnService.isAddonView
            ? this.router.navigate([this.lessonContent.url])
            : Utils.openInNewTab(this.lessonContent.url)
    }
}
